var _Path, _G, _Rect, _G2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G, Circle, Rect, Defs, ClipPath } from "react-native-svg";
var SvgGiftBox = function SvgGiftBox(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "mask0_10084_112051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 0H0v80h55.59a17.298 17.298 0 0 1-6.257-13.333c0-9.573 7.76-17.334 17.334-17.334A17.298 17.298 0 0 1 80 55.591V0Zm0 77.743A17.452 17.452 0 0 1 77.743 80H80v-2.257Z",
    fill: "#F7931A"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#mask0_10084_112051)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 40,
    cy: 40,
    r: 38,
    stroke: "#F7931A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 12,
    y: 12.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#37CC33"
  }), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_10084_112051)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M46.03 28.62c-1.072 1.29-3.035 2.226-4.275 2.619.195-1.229.809-3.227 1.925-4.571.962-1.157 1.622-1.465 2.073-1.465.35 0 .575.186.716.303.314.261 1.27 1.056-.44 3.113Zm-11.878 0c-1.71-2.059-.753-2.853-.44-3.114.324-.268 1.08-.896 2.79 1.161 1.116 1.345 1.73 3.343 1.925 4.572-1.24-.393-3.204-1.33-4.275-2.62Zm12.522 3.694c.684-.49 1.313-1.043 1.817-1.65 2.771-3.336 1.744-6.19.022-7.62-.831-.69-3.811-2.614-7.295 1.579a10.272 10.272 0 0 0-1.127 1.729 10.274 10.274 0 0 0-1.128-1.73c-3.483-4.193-6.464-2.267-7.294-1.578-1.722 1.43-2.75 4.284.02 7.62.506.607 1.134 1.16 1.818 1.65h-9.416v7.606H38.81v-7.606h2.56v7.606H56.09v-7.606h-9.417ZM41.591 57h13V42h-13v15ZM25.591 57h13V42h-13v15Z"
  })))), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 52.5,
    y: 53,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#4285F4"
  })), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip1_10084_112051)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m67.607 56.857-6.428 11.25h4.82l-1.606 8.036 6.428-11.25H66l1.607-8.036Z",
    fill: "white"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_10084_112051"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(22.5 22)",
    d: "M0 0h35v35H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip1_10084_112051"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(56.357 56.857)",
    d: "M0 0h19.286v19.286H0z"
  })))));
};
export default SvgGiftBox;